// Additional steps that make our Vue app run in the browser
import makeStore from 'app/store'
import makeRouter from 'app/router'
import routes from 'app/routes'
import dashboard from 'app/plugins/dashboard'
import SiteLink from 'app/components-wa/nav/SiteLink'
import VueGtag from 'vue-gtag'
import { sync } from 'vuex-router-sync'
import { WEB_AWESOME_LAYOUT } from 'app/router/layouts'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'

import InstantSearch from 'vue-instantsearch'

export default (vueInstance) => {
  const store = makeStore(vueInstance)
  const router = makeRouter(vueInstance, routes)

  sync(store, router)

  vueInstance.use(InstantSearch)

  vueInstance.use(
    VueGtag,
    {
      config: { id: FONTAWESOME.GOOGLE_TRACKING_ID },
      disableScriptLoad: true,
      enabled: FONTAWESOME.GOOGLE_TRACKING_ENABLED === 'yes'
    },
    router
  )

  Sentry.init({
    dsn: FONTAWESOME.SENTRY_PUBLIC_DSN,
    environment: FONTAWESOME.SENTRY_ENV,
    whitelistUrls: [/.*fontawesome.com\/js\/.*/, /.*fa.test.*\/js\/.*/],
    integrations: [new Integrations.Dedupe()],
    beforeSend(event) {
      if (FONTAWESOME.SENTRY_BROWSER_ENABLED === 'yes') {
        return event
      }
    }
  })

  vueInstance.use(dashboard)

  vueInstance.component('site-link', SiteLink(vueInstance, { defaultLayout: WEB_AWESOME_LAYOUT }))

  if (FONTAWESOME.ENV === 'production') {
    vueInstance.config.devtools = false
    vueInstance.config.silent = true
  } else {
    vueInstance.config.performance = true
  }

  const apolloClient = new ApolloClient({
    uri: FONTAWESOME.API_URL
  })

  const apolloProvider = new VueApollo({
    defaultClient: apolloClient
  })

  const App = vueInstance.extend({
    name: 'App',
    template: '<div id="vue-container" @drop.prevent @dragover.prevent><router-view></router-view><dashboard /></div>',
    router,
    apolloProvider,
    store
  })

  const app = new App()

  router.onReady(() => {
    app.$mount('#vue-container')
  })
}
